import BaseComponent from "../../../baseComponent.js";

class FormulaPreview extends BaseComponent {
  handleMouseEnter(e) {
    var currentOption = $(e.currentTarget).siblings(".selected");
    currentOption.removeClass('selected');
    $(e.currentTarget).addClass('selected');
  }

  handleMouseLeave(e) {
    $(e.currentTarget).removeClass('selected');
  }

  render() {
    return (
      <li role="option"
          id={this.props.id}
          tabIndex="0"
          className={this.props.selected ? "selected" : ""}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}>
        <div className="preview-item">
          <div>
            <div className="preview-item__name">{this.props.formula.name}</div>
            <div className="preview-item__ref">{this.props.formula.type}</div>
          </div>
          <div className="preview-item__summary">{this.props.formula.summary}</div>
        </div>
      </li>
    );
  }
}

export default class FunctionList extends BaseComponent {
  render() {
    var options = [];
    for (var i = 0; i < this.props.functionAndDatasetList.length; i++) {
      options.push(<FormulaPreview
        selected={i == 0}
        formula={this.props.functionAndDatasetList[i]}
        id={"f-" + i}
        key={i}/>)
    }
    return (
      <ul id="formula-list" className="formula-bar-popup preview-list"
          tabIndex="-1"
          role="listbox"
          aria-expanded="true">
        {options}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/functions/functionList.jsx